type EnumLikeObj<T extends string> = {
    [key in T]: T;
  };
  
  function getEnumLikeObj<T extends string>(data: T[]): EnumLikeObj<T>  {
    const enumLikeObj = {} as EnumLikeObj<T>;
    data.forEach(item => {
      enumLikeObj[item] = item;
    });
    return enumLikeObj;
  };


  export {getEnumLikeObj};